/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import CircleLoader from "@/Components/Brand/Loader/Loader";
import { Modal1, Modal2 } from "@/Components/Brand/modals/Modals";
import { useAuth } from "@/Providers/Auth";
import { useBrand } from "@/Providers/Brand";
import { useStaticData } from "@/Providers/Data";
import { useGeneralSettings } from "@/Providers/General";
import { Button } from "@/shadcnComponents/ui/button";
import { toast, useToast } from "@/shadcnComponents/ui/use-toast";
import { ArrowRight, LinkedinIcon } from "lucide-react";
import mixpanel from "mixpanel-browser";
import { useEffect, useState } from "react";
import { BiRupee } from "react-icons/bi";
import { CiLock } from "react-icons/ci";
import { GrLanguage } from "react-icons/gr";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { MdOpenInNew, MdWorkOutline } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { cva, VariantProps } from "class-variance-authority";
import { cn } from "../../../../lib/utils";

const convertToUrl = (url) => {
  if (!url) {
    return "";
  }
  url = url?.trim();
  if (!/^https?:\/\//i.test(url)) {
    if (!/^www\./i.test(url)) {
      url = "www." + url;
    }
    url = "https://" + url;
  }
  return url;
};

export const LockedCreatorDetails = () => {
  const { id } = useParams();
  const brandState = useBrand();
  const navigate = useNavigate();
  const staticDataState = useStaticData();
  const authState = useAuth();
  const generalState = useGeneralSettings();

  const [selectedInfluencerName, setSelectedInfluencerName] = useState("");
  const [selectedInfluencerprofile, setSelectedInfluencerProfile] =
    useState("");
  const [openModal, SetOpenModal] = useState(false);
  const [successModal, OpenSuccessModal] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [ChipsRequiredToUnlock, setChipsRequiredToUnlock] = useState(null);
  const [influencer, setinfluencer] = useState({
    influencerData: { name: "", LinkedInFollowers: 0, profile: "" },
    collabData: [],
    AudienceCategory: [],
    MonetizedData: [],
    AudienceData: [],
    ContentCategory: [],
    ContentFormats: [],
    ChargesInfo: [],
    is_unlocked: false,
  });

  //master data
  const [masterContentCategory, setMasterContentCategory] = useState([]);
  const [masterContentFormat, setMasterContentFormat] = useState([]);
  const [, setMasterAudienceTypes] = useState([]);
  const [masterAudiencePlatfroms, setMasterAudiencePlatfroms] = useState([]);
  const [masterCollabGoals, setMasterCollabGoals] = useState([]);
  const [masterMonetizationPlatform, setMasterMonetizationPlatform] = useState(
    []
  );
  const [masterMonetizationServices, setMasterMonetizationServices] = useState(
    []
  );

  // Mixpanel
  useEffect(() => {
    mixpanel.track(
      "Creator Overall details: Locked Creator Details Page Visited"
    );
  }, []);

  // fetching master data
  useEffect(() => {
    staticDataState?.getNewDataFromType("Content Type").then((e) => {
      setMasterContentCategory(e);
    });
    staticDataState?.getNewDataFromType("Content Format").then((e) => {
      setMasterContentFormat(e);
    });
    staticDataState?.getNewDataFromType("Audience Category").then((e) => {
      setMasterAudienceTypes(e);
    });
    staticDataState?.getNewDataFromType("Audience Platform").then((e) => {
      setMasterAudiencePlatfroms(e);
    });
    staticDataState?.getNewDataFromType("Goal / KPI").then((e) => {
      setMasterCollabGoals(e);
    });
    staticDataState?.getNewDataFromType("Platform Name").then((e) => {
      setMasterMonetizationPlatform(e);
    });
    staticDataState?.getNewDataFromType("Services list").then((e) => {
      setMasterMonetizationServices(e);
    });
  }, []);

  // fething creator detials
  useEffect(() => {
    const fetchLockedCreator = async () => {
      try {
        setLoading(true);
        const result = await brandState?.getLockedCreatorDetailsByID(id);
        if (result?.success) {
          if (result?.resolvedInfluencers[0]?.is_unlocked) {
            navigate(
              `/Brand/DashBoard/UnlockedInfluencer/Details/?InfluencerID=${id}`
            );
          }
          setinfluencer(result?.resolvedInfluencers[0]);
          setChipsRequiredToUnlock(result?.ChipsRequiredToUnlock);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.log("failed");
      }
    };

    if (id) fetchLockedCreator();
  }, [id]);

  function convertToReadableFormat(number) {
    if (Math.abs(number) >= 1000000000) {
      return (number / 1000000000).toFixed(1) + "B";
    } else if (Math.abs(number) >= 1000000) {
      return (number / 1000000).toFixed(1) + "M";
    } else if (Math.abs(number) >= 1000) {
      return (number / 1000).toFixed(1) + "K";
    } else {
      return number.toString();
    }
  }

  const handleBuyClick = async () => {
    SetOpenModal(false);
    generalState?.setLoading(true);
    const result = await brandState?.getInfluencerWithCredits(id, false);
    if (result?.success) {
      generalState.setLoading(false);
      const result2 = await brandState?.getInfluencerPersonalInfo(id);
      if (result2?.success) {
        setSelectedInfluencerName(result2?.data?.name);
        setSelectedInfluencerProfile(result2?.data?.profile);
        OpenSuccessModal(true);
        authState?.setReFetchBrandData((prev) => !prev);
      } else {
        generalState.setLoading(false);
        toast({
          title: result2?.Error,
          variant: "destructive",
        });
      }
    } else {
      generalState.setLoading(false);
      toast({
        title: result?.Error,
        variant: "destructive",
      });
    }
  };

  if (!id) {
    window.location.href = "/Brand/Dashboard/Discover";
    navigate("/Brand/Dashboard/Discover", { replace: true });
    return;
  }
  return (
    <>
      {openModal && (
        <Modal1
          credits={authState?.loggedBrand?.credits}
          coins={ChipsRequiredToUnlock}
          onClose={() => {
            return SetOpenModal(false);
          }}
          onBuy={() => handleBuyClick()}
          OnClick={() => navigate("/Brand/DashBoard/PurchaseCredits")}
        />
      )}
      {successModal && (
        <Modal2
          onClick={() =>
            navigate(
              `/Brand/DashBoard/UnlockedInfluencer/Details/?InfluencerID=${id}`
            )
          }
          onClose={() => {
            return OpenSuccessModal(false);
          }}
          name={selectedInfluencerName}
          profile={selectedInfluencerprofile}
        />
      )}
      <div className="w-full relative min-h-full h-max items-start flex px-[40px] pt-7 pb-[40px] gap-[40px] text-[Inter] bg-white">
        <div className="w-[65%] flex flex-col gap-4 ">
          <h2 className="text-[1.5rem] font-bold flex gap-[12px]">
            <button onClick={() => navigate("/Brand/DashBoard/Discover")}>
              <HiArrowNarrowLeft size={20} />
            </button>
            Creator Overall details
          </h2>
          {Loading && <CircleLoader />}
          {(influencer?.collabData?.[0]?.data?.length > 0 ||
            influencer?.MonetizedData?.[0]?.data?.length > 0 ||
            influencer?.ContentCategory?.[0]?.length > 0 ||
            influencer?.AudienceData?.[0]?.data?.length > 0 ||
            influencer?.AudienceCategory?.[0]?.length > 0) && (
            <>
              {/* Collaboration Portfolio ---------- */}
              {influencer?.collabData?.[0]?.data &&
                influencer?.collabData?.[0]?.data?.length > 0 && (
                  <SectionCard
                    title="Creator Insights"
                    subtitle="The creator has collaborated with these companies & helped them to grow"
                    icon={"🫱🏼‍🫲🏽"}
                  >
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6">
                      {influencer?.collabData?.[0]?.data?.map(
                        (collab, index) => {
                          return (
                            <CollaborationPortfolioCard
                              key={index}
                              companyName={collab?.companyName}
                              companyUrl={collab?.companyUrl}
                              goals={collab?.goals}
                              postLink={collab?.postLink}
                              isVerified={collab?.isVerified}
                              masterData={masterCollabGoals}
                              postContent={collab?.post?.postContent}
                            />
                          );
                        }
                      )}
                    </div>
                  </SectionCard>
                )}

              {/* Monetization Avenue ------------------- */}
              {influencer?.MonetizedData?.[0]?.data &&
                influencer?.MonetizedData?.[0]?.data?.length > 0 && (
                  <SectionCard
                    title="Monetization Avenue"
                    subtitle="The creator is monetizing via the following platforms"
                    icon={"💰"}
                  >
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6">
                      {influencer?.MonetizedData?.[0]?.data?.map(
                        (data, index) => {
                          return (
                            <MonetizationAvenueCard
                              key={index}
                              platformname={
                                masterMonetizationPlatform?.find(
                                  (platform) =>
                                    platform?._id === data?.platformName
                                )?.monetizationPlatformName
                              }
                              profileLink={data?.profileLink}
                              paidAudience={data?.paidAudience}
                              methods={data?.methods?.map((method) => {
                                const methodName =
                                  masterMonetizationServices?.find(
                                    (mastermethod) =>
                                      mastermethod?._id === method
                                  );
                                return methodName?.monetizationServiceName;
                              })}
                              plateformLogo={
                                masterMonetizationPlatform?.find(
                                  (platform) =>
                                    platform?._id === data?.platformName
                                )?.monetizationPlatformIcon
                              }
                            />
                          );
                        }
                      )}
                    </div>
                  </SectionCard>
                )}

              {/* Audience Avenues ---------------- */}
              {influencer?.AudienceData?.[0]?.data &&
                influencer?.AudienceData?.[0]?.data?.length > 0 && (
                  <SectionCard
                    title="Audience Avenues"
                    subtitle="The creator can promote your products across platforms to their audience"
                    icon={"👩🏻‍🤝‍👩🏼"}
                  >
                    <div className="flex items-start gap-[20px] self-stretch flex-wrap">
                      {influencer?.AudienceData?.[0]?.data?.map(
                        (data, index) => {
                          return (
                            data?.audience > 0 &&
                            data?.platform && (
                              <AudienceAvenuesCard
                                key={index}
                                platform={
                                  masterAudiencePlatfroms?.find(
                                    (platform) =>
                                      platform?._id === data?.platform
                                  )?.audiencePlatformName
                                }
                                audience={data?.audience}
                                link={data?.link}
                                icon={
                                  masterAudiencePlatfroms?.find(
                                    (platform) =>
                                      platform?._id === data?.platform
                                  )?.audiencePlatformIcon
                                }
                              />
                            )
                          );
                        }
                      )}
                    </div>
                  </SectionCard>
                )}

              {/* Content Category ---------------- */}
              {influencer?.ContentCategory?.[0] &&
                influencer?.ContentCategory?.[0]?.length > 0 && (
                  <SectionCard
                    title="Content Category"
                    subtitle="The creator majorly talks on these topics and categories"
                    icon={"💭"}
                  >
                    <div className="flex items-start gap-[8px] flex-wrap">
                      {influencer?.ContentCategory?.[0]
                        ?.slice(0, 6)
                        .map((data, index) => {
                          return (
                            <TagChip
                              key={index}
                              text={
                                masterContentCategory?.find(
                                  (category) => category?._id === data
                                )?.categoryName
                              }
                            />
                          );
                        })}
                      {influencer?.ContentCategory?.[0]?.length > 6 && (
                        <TagChip
                          text={`+${
                            influencer?.ContentCategory?.[0]?.length - 6
                          }`}
                        />
                      )}
                    </div>
                  </SectionCard>
                )}

              {/* Content Format ---------------- */}
              {influencer?.ContentFormats?.[0] &&
                influencer?.ContentFormats?.[0]?.length > 0 && (
                  <SectionCard
                    title="Content Format"
                    subtitle="The creator is comfortable using these formats to convey your message"
                    icon={"💭"}
                  >
                    <div className="flex items-start gap-[8px] flex-wrap">
                      {influencer?.ContentFormats?.[0]?.map((data, index) => {
                        return (
                          <TagChip
                            key={index}
                            text={
                              masterContentFormat?.find(
                                (category) => category?._id === data
                              )?.contentFormatName
                            }
                          />
                        );
                      })}
                    </div>
                  </SectionCard>
                )}
            </>
          )}
        </div>
        {ChipsRequiredToUnlock && (
          <div className="sticky top-20 space-y-10 w-[30%]">
            <div className="border border-[#DBDBDB] rounded-[8px] flex  p-[16px] flex-col items-center bg-white shrink-0">
              <div className="flex flex-col gap-2">
                <div className="text-[#121212] text-center text-[28px] font-bold">
                  {influencer?.influencerData?.name}
                </div>
                {influencer?.influencerData?.LinkedInFollowers && (
                  <div className="flex gap-1 justify-center items-center">
                    <LinkedinIcon size={20} color="#6B7286" />
                    <span className="text-[#6B7286] text-center font-[Inter] text-[14px] not-italic font-normal leading-[24px]">
                      {convertToReadableFormat(
                        influencer?.influencerData?.LinkedInFollowers
                      )}
                    </span>
                  </div>
                )}
                {influencer?.ChargesInfo?.[0]?.PostMinPrice?.[0] &&
                  influencer?.ChargesInfo?.[0]?.PostMaxPrice?.[0] && (
                    <>
                      <span className="text-[#6B7286] text-center font-[Inter] text-[14px] not-italic font-normal leading-[24px]">
                        Charges Per Post
                      </span>
                      <div className="flex justify-center items-center">
                        <BiRupee size={24} color="#121212" />
                        <span className="text-[#121212] font-[Inter] text-[14px] not-italic font-bold leading-[24px]">
                          {influencer?.ChargesInfo?.[0]?.PostMinPrice?.[0]} -{" "}
                          {influencer?.ChargesInfo?.[0]?.PostMaxPrice?.[0]}
                        </span>
                      </div>
                    </>
                  )}
                <div className="flex gap-4 flex-wrap justify-center items-center">
                  <TagChip
                    text={`Negotiable: ${
                      influencer?.ChargesInfo?.[0]?.isNegotiable?.[0]
                        ? "Yes"
                        : "No"
                    }`}
                  />
                  <TagChip
                    text={`Bartering: ${
                      influencer?.ChargesInfo?.[0]?.AcceptFreeBies?.[0]
                        ? "Yes"
                        : "No"
                    }`}
                  />
                </div>
              </div>
            </div>
            <div className="border border-[#262626] rounded-[8px] flex  p-[16px] flex-col items-center bg-white shrink-0">
              <div className="flex flex-col gap-2 justify-center items-center">
                <span className="text-[#121212] text-center text-[28px] font-bold">
                  Unlock Creator
                </span>
                <span className="text-[#6B7286] text-center text-[14px] leading-[24px]">
                  Required Credits
                </span>
                <TagChip text={`${ChipsRequiredToUnlock} Credits`} />
                <span className="text-[#6B7286] text-center text-[14px] leading-[24px]">
                  You have {authState?.loggedBrand?.credits} Credits
                </span>
                {/* <span className="text-[#6B7286] text-center text-[14px] leading-[24px]">
                    Unlock at 280 with paid plan
                    </span> */}
                {/* <span className="text-[#FF4040] text-center text-[14px] leading-[24px]">
                    Select Paid Plan
                    </span> */}

                {/* Target Button */}
                <Button
                  className="gap-2 whitespace-pre-wrap flex-wrap"
                  onClick={() => {
                    SetOpenModal(true);
                    mixpanel.track("Clicked on Unlock Creator Button", {
                      creatorId: id,
                    });
                  }}
                >
                  Unlock by using {ChipsRequiredToUnlock} Credits
                  <ArrowRight size={16} color="#FFFFFF" />
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

interface SectionCardProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  icon?;
  sectionClass?: string;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  children,
  icon,
  title,
  subtitle,
  sectionClass,
}) => {
  return (
    <div
      className={cn(
        "flex p-[16px] flex-col items-start gap-[20px] rounded-[8px] border-[1px] border-solid border-[#DBDBDB] bg-white",
        sectionClass
      )}
    >
      <div className="flex flex-col items-start gap-[8px] self-stretch">
        <div className="flex items-start gap-[8px] self-stretch">
          <span className="text-[#121212] text-center font-[Inter] text-[24px] not-italic font-normal leading-[20px]">
            {icon}
          </span>
          <span className="text-[#121212] text-center font-[Inter] text-base not-italic font-semibold leading-[20px]">
            {title}
          </span>
        </div>
        <span className="self-stretch text-[#919191] font-[Inter] text-sm not-italic font-normal leading-[20px]">
          {subtitle}
        </span>
      </div>
      {children}
    </div>
  );
};

interface CollaborationPortfolioCardProps {
  companyName?: string;
  companyProfile?: string;
  companyUrl?: string;
  goals?: string[];
  postLink?: string;
  masterData?: any[];
  isVerified?: number;
  postContent?: string;
}

export const CollaborationPortfolioCard: React.FC<
  CollaborationPortfolioCardProps
> = ({
  companyName,
  companyUrl,
  goals,
  postLink,
  masterData,
  isVerified,
  postContent,
}) => {
  const { toast } = useToast();

  // TODO - API data integration - postContent
  // postContent =
  //   postContent ||
  //   `Hi All, I'm looking to hire an intern with an engineering background to support an upcoming project. This would be a 3-month`;

  return (
    <div className="flex px-[16px] py-[12px] flex-col gap-[20px] self-stretch rounded-[6px] border-solid w-full justify-between border-[1px] border-[solid] border-[#EEE] bg-[#FFF] [box-shadow:0px_4px_4px_0px_rgba(0,_0,_0,_0.25)]">
      <div className="flex flex-col gap-[20px]">
        <div className="flex justify-between items-start self-stretch">
          <div className="flex flex-col justify-center items-start gap-[8px] overflow-hidden text-ellipsis whitespace-nowrap">
            <div className="flex flex-col justify-center items-start gap-[8px]">
              <div className="flex items-center gap-[6px]">
                <div className="flex items-center justify-center w-[16px] h-[16px]">
                  <MdWorkOutline color="#5A5A5A" size={16} />
                </div>
                <span className="text-[#000] font-[Inter] text-[14px] not-italic font-medium leading-[normal]">
                  {companyName}
                </span>
              </div>
              {companyUrl &&
                companyUrl?.trim().length > 0 &&
                companyUrl !== null && (
                  <>
                    <div className="flex items-center gap-[6px]">
                      <div className=" flex items-center justify-center w-[16px] h-[16px]">
                        <GrLanguage color="#5A5A5A" size={14} />
                      </div>
                      <button
                        className="text-[#06F] font-[Inter] text-[12px] not-italic font-normal leading-[normal]"
                        onClick={() => {
                          mixpanel.track(
                            `Clicked companyUrl on profile on Collab`,
                            { companyName: companyName, companyUrl: companyUrl }
                          );
                          window.open(convertToUrl(companyUrl), "_blank");
                        }}
                      >
                        {companyUrl.replace(/^https?:\/\//i, "").slice(0, 15) +
                          "..."}
                      </button>
                    </div>
                  </>
                )}
            </div>
          </div>
          {isVerified === 1 && (
            <div
              className="flex items-center gap-[4px] cursor-pointer"
              onClick={() => {
                mixpanel.track("clicked on collab verified logo");
                toast({
                  title: "The Company Verified this collaboration",
                });
              }}
            >
              <div className="w-[16px] h-[16px]">
                <img
                  src={
                    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/verifiedCheck.gif"
                  }
                  alt="verified"
                />
              </div>
              <span className="text-[#121212] font-[Inter] text-[12px] not-italic font-semibold leading-[normal] uppercase">
                Verified
              </span>
            </div>
          )}
        </div>
        {goals && goals?.length > 0 && (
          <>
            <div className="flex flex-col justify-center items-start gap-[8px]">
              <div className="flex items-center gap-[6px]">
                <span className="text-[#E2E8F0] font-[Inter] text-[16px] not-italic font-normal leading-[normal]">
                  🎯
                </span>
                <span className="text-[#DC2627] font-[Inter] text-[12px] not-italic font-medium leading-[normal]">
                  Collab Goals
                </span>
              </div>
              <div className="flex items-start gap-[8px] flex-wrap">
                {goals?.map((goal, index) => {
                  return (
                    <TagChip
                      key={index}
                      categoryId={goal}
                      masterData={masterData}
                      variant={"outline"}
                    />
                  );
                })}
              </div>
            </div>
          </>
        )}
      </div>
      <div>
        {postContent && postContent?.length > 0 && (
          <div>
            <div className="flex items-center gap-[6px]">
              <span className="text-[#E2E8F0] font-[Inter] text-[16px] not-italic font-normal leading-[normal]">
                🎯
              </span>
              <span className="text-[#DC2627] font-[Inter] text-[12px] not-italic font-medium leading-[normal]">
                Collaboration Post
              </span>
            </div>
            {/*  TODO - API data integration - postContent */}
            <div className="text-[#545454] font-[Inter] text-[12px] not-italic font-normal leading-[22px] line-clamp-4">
              {postContent}
            </div>
          </div>
        )}
        <div className="flex justify-start">
          {postLink && (
            <button
              className={twMerge(
                `flex py-[6px] justify-center items-center gap-[4px] text-[#121212] font-[Inter] text-[12px] not-italic font-medium leading-[normal]`,
                !postLink && `cursor-not-allowed`
              )}
              onClick={() => {
                mixpanel.track(`Clicked Proof on Collaboration History`, {
                  companyName: companyName,
                  postLink: postLink,
                });
                window.open(convertToUrl(postLink), "_blank");
              }}
              disabled={!postLink}
            >
              <span>View Full Post</span>
              {!postLink ? (
                <CiLock size={14} color="#DC2627" />
              ) : (
                <MdOpenInNew size={14} color="#DC2627" />
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

interface MonetizationAvenueCardProps {
  platformname: string;
  profileLink: string;
  paidAudience: number;
  methods: string[];
  plateformLogo?: string;
}

export const MonetizationAvenueCard: React.FC<MonetizationAvenueCardProps> = ({
  platformname,
  profileLink,
  paidAudience,
  methods,
  plateformLogo,
}) => {
  return (
    <div className="flex px-[16px] py-[12px] flex-col gap-[20px] self-stretch rounded-[6px] bg-white border-[1px] border-solid border-[#DBDBDB] w-full  [box-shadow:0px_4px_4px_0px_rgba(0,_0,_0,_0.25)] justify-between">
      <div className="flex flex-col gap-[20px]">
        {/* Head */}
        <div className="flex items-center gap-[8px] self-stretch overflow-hidden text-ellipsis whitespace-nowrap">
          <div className="w-[40px] h-[40px] bg-white rounded-full flex justify-center items-center shrink-0">
            {plateformLogo ? (
              <img
                src={plateformLogo}
                alt={`${platformname} logo`}
                className="w-full h-full object-cover rounded-full"
              />
            ) : (
              "🌐"
            )}
          </div>
          <div className="flex flex-col justify-center items-start gap-[8px]">
            <span className="font-[Inter] text-[14px] not-italic font-semibold leading-[normal]">
              {platformname}
            </span>
            {profileLink &&
              profileLink.trim().length > 0 &&
              profileLink !== null && (
                <button
                  className="text-[#06F] font-[Inter] text-[12px] not-italic font-normal leading-[normal]"
                  onClick={() => {
                    mixpanel.track(
                      `Clicked profileLink on profile Monetization Channels`,
                      { platformname: platformname, profileLink: profileLink }
                    );
                    window.open(convertToUrl(profileLink), "_blank");
                  }}
                >
                  {profileLink.replace(/^https?:\/\//i, "").slice(0, 15) +
                    "..."}
                </button>
              )}
            {!profileLink && (
              <span className="flex gap-1 justify-center items-center text-[#06F] font-[Inter] text-[12px] not-italic font-normal leading-[normal] cursor-not-allowed">
                View Profile
                <CiLock size={14} color="#06F" />
              </span>
            )}
          </div>
        </div>

        {/* Body */}
        {methods?.length > 0 && (
          <>
            <div className="flex flex-col justify-center items-start gap-[8px] self-stretch">
              <span className="text-[#6B7286] font-[Inter] text-[12px] not-italic font-normal leading-[normal]">
                Services
              </span>
              <div className="flex items-start gap-[8px] flex-wrap">
                {methods.map((method, index) => {
                  return (
                    <TagChip variant="outline" key={index} text={method} />
                  );
                })}
              </div>
            </div>
          </>
        )}
      </div>

      {/* Footer */}
      {paidAudience >= 1 && (
        <>
          <div className="flex justify-end">
            <div className="flex px-[12px] py-[6px] items-center gap-[4px] rounded-[2px] border-[1px] border-solid border-[#FFB042] bg-[rgba(255,_176,_66,_0.12)]">
              <span>🔥</span>
              <span className="text-[rgb(19,18,18)] font-[Inter] text-[12px] not-italic font-normal leading-[normal]">
                {paidAudience}+ Purchased
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

interface AudienceAvenuesCardProps {
  platform: string;
  audience: number;
  link?: string;
  icon: string;
}

export const AudienceAvenuesCard: React.FC<AudienceAvenuesCardProps> = ({
  platform,
  audience,
  icon,
  link,
}) => {
  const cardColor = {
    whatsapp: "border-[#60D669] bg-[rgba(96,_214,_105,_0.08)]",
    telegram: "border-[#2BACEF] bg-[rgba(43,_172,_239,_0.08)]",
    instagram: "border-[#E5476D] bg-[rgba(229,_71,_109,_0.08)]",
    linkedin: "border-[#0076B2] bg-[rgba(0,_118,_178,_0.08)]",
    youtube: "border-[#F00] bg-[rgba(255,_0,_0,_0.08)]",
  };

  let colorClass = "";

  Object.keys(cardColor).forEach((key) => {
    if (platform?.toLowerCase().includes(key)) {
      colorClass = cardColor[key];
    }
  });

  return (
    <button
      className={twMerge(
        "md:max-w-[175px] flex px-[20px] py-[16px] justify-center items-center gap-4 flex-[1_0_0] rounded-[4px] border-[1px] border-solid border-[#60D669] bg-[rgba(96,_214,_105,_0.08)]",
        colorClass,
        `${!link && "cursor-not-allowed"}`
      )}
      onClick={() => {
        mixpanel.track(
          `Clicked ${platform} on public profile Platform Presence`,
          { platform: platform, audience: audience }
        );
        window.open(link, "_blank");
      }}
      disabled={!link}
    >
      <img src={icon} alt={platform} className="w-[28px] h-[28px]" />
      <div className="flex flex-col items-center gap-[2px]">
        <span className="text-[#121212] text-center font-[Inter] text-[14px] not-italic font-normal leading-[normal]">
          {audience}
        </span>
        <span className="text-[#919191] text-center font-[Inter] text-[12px] not-italic font-normal leading-[normal]">
          Users
        </span>
      </div>
    </button>
  );
};

// type TagChipProps = {
//   categoryId?: string;
//   masterData?: any[];
//   text?: string;
//   variant?: "default" | "plain";
// };

// const TagChip = ({
//   categoryId,
//   masterData,
//   text = "",
//   variant = "default",
// }: TagChipProps) => {
//   const chipColors = [
//     { bg: "#FFE6E6", text: "#FF6B6B" },
//     { bg: "#FFF3CC", text: "#FFC107" },
//     { bg: "#E6F4E6", text: "#4CAF50" },
//     { bg: "#E6F0FF", text: "#2196F3" },
//     { bg: "#F0E6F4", text: "#9B59B6" },
//     { bg: "#FFE6EF", text: "#E91E63" },
//     { bg: "#FFE6E6", text: "#F44336" },
//     { bg: "#E6E4F4", text: "#673AB7" },
//     { bg: "#CCF0F4", text: "#00BCD4" },
//     { bg: "#E6F0CC", text: "#8BC34A" },
//   ];

//   const [randomColorPair, setRandomColorPair] = useState({
//     bg: "#FFE6E6",
//     text: "#FF6B6B",
//   });

//   if (categoryId && masterData) {
//     text = masterData.find((item) => item?._id === categoryId)?.CollabGoalsName;
//   }

//   useEffect(() => {
//     setRandomColorPair(
//       chipColors[Math.floor(Math.random() * chipColors.length)]
//     );
//   }, []);

//   const styles = {
//     default: "",
//     plain: "",
//   }[variant];

//   return (
//     <span
//       className={cn(
//         "shrink-0 px-2 py-1 rounded-full text-xs font-medium",
//         styles
//       )}
//       style={{
//         backgroundColor: randomColorPair?.bg,
//         color: randomColorPair?.text,
//       }}
//     >
//       {text}
//     </span>
//   );
// };

// ------------------ TagChips ------------------

type TagChipProps = {
  categoryId?: string;
  masterData?: any[];
  text?: string;
  className?: string;
} & VariantProps<typeof tagChipStyles>;

const tagChipStyles = cva("shrink-0 px-2 py-1 text-[0.8rem] font-medium", {
  variants: {
    variant: {
      default: "bg-[#A3A3A3] text-[#FF6B6B] rounded-full",
      outline:
        "bg-transparent text-[#A3A3A3] border border-[#DBDBDB] rounded-[6px]",
      colored: "py-[10px] px-[20px] rounded-[6px]",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export const TagChip = ({
  categoryId,
  masterData,
  text = "",
  variant = "default",
  className,
}: TagChipProps) => {
  // const chipColors = [
  //   { bg: "#FFE6E6", text: "#FF6B6B" },
  //   { bg: "#FFF3CC", text: "#FFC107" },
  //   { bg: "#E6F4E6", text: "#4CAF50" },
  //   { bg: "#E6F0FF", text: "#2196F3" },
  //   { bg: "#F0E6F4", text: "#9B59B6" },
  //   { bg: "#FFE6EF", text: "#E91E63" },
  //   { bg: "#FFE6E6", text: "#F44336" },
  //   { bg: "#E6E4F4", text: "#673AB7" },
  //   { bg: "#CCF0F4", text: "#00BCD4" },
  //   { bg: "#E6F0CC", text: "#8BC34A" },
  // ];
  const chipColors = [
    { bg: "#FAB27B4D", text: "#AE4B00" },
    { bg: "#9AC2FF4D", text: "#0147B1" },
    { bg: "#BA41C41F", text: "#86198F" },
    { bg: "#8BF2EC33", text: "#00A096" },
    { bg: "#FF8C8D4D", text: "#B70103" },
  ];

  const [randomColorPair, setRandomColorPair] = useState({
    bg: "#FFE6E6",
    text: "#FF6B6B",
  });

  if (categoryId && masterData) {
    text = masterData.find((item) => item?._id === categoryId)?.CollabGoalsName;
  }

  useEffect(() => {
    setRandomColorPair(
      chipColors[Math.floor(Math.random() * chipColors.length)]
    );
  }, []);

  const dynamicStyles =
    variant === "default" || variant === "colored"
      ? {
          backgroundColor: randomColorPair.bg,
          color: randomColorPair.text,
        }
      : {};

  return (
    <span
      className={cn(tagChipStyles({ variant }), className)}
      style={dynamicStyles}
    >
      {text}
    </span>
  );
};
